/* Hero background video — make autoplay actually happen on phones.

   The markup already carries autoplay/loop/muted/playsinline, which is what the
   spec asks for, and it is enough on desktop. It is not enough on a phone:

   1. Some browsers ignore the `muted` ATTRIBUTE when it arrives in parsed
      markup and only honour the muted PROPERTY. An unmuted video fails the
      autoplay policy and is rejected silently. product.js already carries this
      same fix for the UGC strip; the hero never got it.

   2. A rejected play() returns a rejected promise and nothing else. With no
      handler there is no retry and no signal — the hero just sits there.

   3. iOS Low Power Mode and Android Data Saver refuse autoplay outright, and no
      attribute overrides them. The only recovery is a user gesture, so the first
      real interaction re-attempts playback.

   When playback genuinely cannot start the poster and the layered fallback
   image stay visible, so the hero is still a composed frame rather than a void.
   That is handled in CSS; this file only ever tries to start playback. */
(function () {
  var videos = document.querySelectorAll('.hero__video');
  if (!videos.length) return;

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(videos, function (video) {
    /* Setting the properties is what satisfies the autoplay policy; the
       attributes alone are not reliably honoured. */
    video.muted = true;
    video.playsInline = true;
    video.loop = true;

    /* Null-guarded: a thrown TypeError here would abort the whole handler and
       take the play() attempt with it, turning a cosmetic class into the very
       failure this file exists to prevent. */
    var section = video.closest('.hero');
    var mark = function (cls) {
      if (section) section.classList.add(cls);
    };

    /* A reduced-motion visitor keeps the poster. Marking the section means the
       still is a deliberate state, not a failed video. */
    if (reduceMotion) {
      mark('hero--video-still');
      return;
    }

    video.addEventListener('playing', function () {
      mark('hero--video-playing');
    });

    var attempt = function () {
      if (!video.paused) return Promise.resolve();
      var p = video.play();
      return p && p.catch ? p.catch(function () {}) : Promise.resolve();
    };

    attempt();

    /* Retry on the first gesture. Low Power Mode rejects the load-time attempt
       but allows a gesture-initiated one, so this is the difference between a
       hero that stays frozen for the whole visit and one that starts as soon as
       the visitor touches the page. Once is enough — hence { once: true }. */
    var kick = function () {
      attempt();
    };
    ['touchstart', 'pointerdown', 'scroll'].forEach(function (evt) {
      window.addEventListener(evt, kick, { once: true, passive: true });
    });

    /* Restoring from the back/forward cache leaves the element paused. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) attempt();
    });
  });
})();
